import { reducer } from './reducer';
import CustomerSettings from '../../lib/interfaces/CustomerSettings';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface CustomerSettingsState {
  settings?: CustomerSettings
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.

interface SetCustomerSettingsAction {
  type: "SET_CUSTOMER_SETTINGS";
  settings: CustomerSettings
}

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownOrderPadAction = SetCustomerSettingsAction;

export const unloadedCustomerSettingsState: CustomerSettingsState = { 
  settings: undefined
};

export { reducer };